document.addEventListener('DOMContentLoaded', function() {
  // Initialize icon URLs with fallbacks
  window.iconVGUrl = window.iconVGUrl || '';
  window.iconArchUrl = window.iconArchUrl || '';
  window.iconMapPinUrl = window.iconMapPinUrl || '';
  window.iconPlainUrl = window.iconPlainUrl || '';
  window.iconDeliveryUrl = window.iconDeliveryUrl || '';

  // Debug logging for initialization
  console.log('Initial variantAvailabilityData:', window.variantAvailabilityData);
  console.log('Initial productHandle:', window.productHandle);

  // Ensure global variables exist
  if (!window.variantAvailabilityData) {
    console.warn('variantAvailabilityData is not initialized');
    window.variantAvailabilityData = {};
  }

  // Helper function to safely get container
  function getAvailabilityContainer(sectionId) {
    const containerId = `product-availability-${sectionId || ShopifyAnalytics?.meta?.page?.pageType || 'product'}`;
    const container = document.getElementById(containerId);
    if (!container) {
      console.warn(`Availability container not found with ID: ${containerId}`);
    }
    return container;
  }

  // Helper function to safely update container
  function updateAvailabilityContainer(container, html) {
    if (container) {
      container.innerHTML = html || '';
      container.style.display = html ? '' : 'none';
    }
  }

  function renderAvailabilityHTML(variantData) {
    // Debug logging for variant data
    console.log('Rendering availability for variant data:', variantData);
    
    // Проверяем наличие на складах по метафилдам
    const booleanArkh = variantData._Arkhangelskoe && variantData._Arkhangelskoe != 0;
    const booleanCB   = variantData._CB && variantData._CB != 0;
    const booleanVG   = variantData._VG && variantData._VG != 0;
    const booleanUS   = variantData._US && variantData._US != 0;

    console.log('Availability flags:', {
      Arkhangelskoe: booleanArkh,
      CB: booleanCB,
      VG: booleanVG,
      US: booleanUS
    });

    if (booleanArkh || booleanCB || booleanVG || booleanUS) {
      let html = '<p class="caption-large availability-block-title">Товар в наличии:</p>';
      if (booleanVG) {
        html += `
          <availability-block-preview class="availability-block-preview">
            ${iconHTML('vg')}
            <div class="availability-block-info">
              <p class="caption-large">В Sortage. Времена Года</p>
            </div>
          </availability-block-preview>
        `;
      }
      if (booleanArkh) {
        html += `
          <availability-block-preview class="availability-block-preview">
            ${iconHTML('arkh')}
            <div class="availability-block-info">
              <p class="caption-large">В Sortage. Архангельское</p>
            </div>
          </availability-block-preview>
        `;
      }
      if (booleanCB) {
        html += `
          <availability-block-preview class="availability-block-preview">
             ${iconHTML('map-pin')}
            <div class="availability-block-info">
              <p class="caption-large">На складе в Москве</p>
            </div>
          </availability-block-preview>
        `;
      }
      if (booleanUS) {
        html += `
          <availability-block-preview class="availability-block-preview">
            ${iconHTML('box')}
            <div class="availability-block-info">
              <p class="caption-large">На удаленном складе</p>
            </div>
          </availability-block-preview>
        `;
      }
      return html;
    } else {
      return `
        <p class="caption-large availability-order-title">Товар доступен под заказ:</p>
        <availability-block-preview class="availability-block-preview">
          ${iconHTML('plain')}
          <div class="availability-block-info">
            <p class="caption-large">Авиа-экспресс: 8 рабочих дней</p>
          </div>
        </availability-block-preview>
        <availability-block-preview class="availability-block-preview">
          ${iconHTML('delivery')}
          <div class="availability-block-info">
            <p class="caption-large">Под заказ: 15-20 рабочих дней</p>
          </div>
        </availability-block-preview>
      `;
    }
  }

  function iconHTML(name) {
    if(name === 'vg') {
      return `<img src="${window.iconVGUrl}" alt="VG Icon">`;
    } else if(name === 'arkh') {
      return `<img src="${window.iconArchUrl}" alt="Arch Icon">`;
    } else if(name === 'map-pin') {
      return `<img src="${window.iconMapPinUrl}" alt="Map Pin Icon">`;
    } else if(name === 'box') {
      return '<!-- HTML иконки box -->';
    } else if (name === 'plain') {
      return `<img src="${window.iconPlainUrl}" alt="Plain Icon">`;
    } else if (name === 'delivery') {
      return `<img src="${window.iconDeliveryUrl}" alt="Delivery Icon">`;
    }
    return '';
  }

  // Subscribe to variant changes with proper error handling
  if (typeof subscribe === 'function' && PUB_SUB_EVENTS?.variantChange) {
    subscribe(PUB_SUB_EVENTS.variantChange, ({ data: { variant } }) => {
      try {
        // Debug logging for variant change
        console.log('Variant change event:', variant);
        console.log('Current productHandle:', window.productHandle);
        
        // Skip if no variant or product handle
        if (!variant || !window.productHandle) {
          console.warn('Missing variant or product handle:', {
            variant: variant,
            productHandle: window.productHandle
          });
          return;
        }

        const key = `${window.productHandle}_${variant.id}`;
        console.log('Looking up variant data with key:', key);
        
        const container = getAvailabilityContainer(variant?.sectionId);
        console.log('Found container:', container);

        // Clear container first
        updateAvailabilityContainer(container, '');

        // Get and render availability data
        const data = window.variantAvailabilityData[key];
        console.log('Found variant data:', data);
        
        if (data) {
          const newHTML = renderAvailabilityHTML(data);
          updateAvailabilityContainer(container, newHTML);
          console.log('Availability block updated with HTML:', newHTML);
        } else {
          console.warn('No availability data found for variant:', key);
          updateAvailabilityContainer(container, '');
        }
      } catch (error) {
        console.error('Error updating availability:', error);
        const container = getAvailabilityContainer();
        updateAvailabilityContainer(container, '');
      }
    });
  } else {
    console.warn('PubSub system not available');
  }
});
